module.exports = __webpack_public_path__ + "img/az.4331dbe5.svg";